var React = require('react');

function AdTrackersIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#4iuvi4dema)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M28.889 5.555H40V30H0V5.555h11.111V0h2.223v5.555h13.332V0h2.223v5.555zm0 2.223v4.445h-2.223V7.777H13.334v4.446H11.11V7.777H2.222v20h35.556v-20h-8.89zm-7.776 26.667V40h-2.226v-5.555H2.223v-2.223h35.556v2.223H21.113zM6.666 12.222H17.78v2.223H6.666v-2.223zm15.556 0h11.112v2.223H22.22l.002-2.223z","fill":"#fff"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"4iuvi4dema"},React.createElement("path",{"fill":"#fff","d":"M0 0h40v40H0z"})))]);
}

AdTrackersIcon.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = AdTrackersIcon;

AdTrackersIcon.default = AdTrackersIcon;
